<div class="security-penalty-bar-container">
  @if (_penaltyBarData && !_penaltyBarData.multipleSecurity) {
    <div>
      <div>
        Penalties are imposed by Mutual Fund companies and cannot be edited.
      </div>
      <div class="security-penalty-detail-container">
        <span>Amt:</span> <span id="penaltyAmt"
      class="security-penalty-detail-value">${{penaltyAmt | number:'1.2-2' }}</span>
      <span>Days:</span> <span id="penaltyDays"
    class="security-penalty-detail-value">{{penaltyDays|number}}</span>
    <span>Amt:</span><span id="penaltyAmtPercentage"
    class="security-penalty-detail-value">{{ penaltyAmtPercentage | number : '1.2-2'}}
  %</span>
  <span>Days:</span> <span id="penaltyDaysPercentage"
class="security-penalty-detail-value">{{penaltyDaysPercentage | number}}</span>
</div>
</div>
}
@if (_penaltyBarData && _penaltyBarData.multipleSecurity) {
  <div>
    <p> Penalties are imposed by Mutual Fund companies and cannot be edited.
    </p>
    <p>Penalty info cannot be edited for multiple securities.</p>
  </div>
}
</div>
